import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-custom-page4',
  templateUrl: './crm-custom-page4.component.html',
  styleUrls: ['./crm-custom-page4.component.css']
})
export class CrmCustomPage4Component {

}
